export const DECISION_TABLE = {
  //Decisiontable view

  "Decisiontable.Space.Around": {
    defaultValue: "default"
  },
  "Decisiontable.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Decisiontable.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Decisiontable.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Decisiontable.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Decisiontable.Height.Type": {
    defaultValue: "fixed"
  },

  "Decisiontable.Bg.Color": {
    ref: "Color.White"
  },

  "Decisiontable.Overflow": {
    defaultValue: "auto"
  },

  "Decisiontable.Height": {
    defaultValue: "500px"
  },
  "Decisiontable.Width": {
    defaultValue: "100%"
  },
  "Decisiontable.Min.Height": {
    defaultValue: "0px"
  },
  "Decisiontable.Min.Width": {
    defaultValue: "750px"
  },
  "Decisiontable.Max.Height": {
    defaultValue: "unset"
  },
  "Decisiontable.Max.Width": {
    defaultValue: "unset"
  },

  "Decisiontable.Margin.Top": {
    defaultValue: "0px"
  },
  "Decisiontable.Margin.Right": {
    defaultValue: "0px"
  },
  "Decisiontable.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Decisiontable.Margin.Left": {
    defaultValue: "0px"
  },

  "Decisiontable.Padding.Top": {
    defaultValue: "0px"
  },
  "Decisiontable.Padding.Right": {
    defaultValue: "0px"
  },
  "Decisiontable.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Decisiontable.Padding.Left": {
    defaultValue: "0px"
  },

  "Decisiontable.Border.Style": {
    defaultValue: "solid"
  },
  "Decisiontable.Border.Color": {
    ref: "Color.Transparent"
  },

  "Decisiontable.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Decisiontable.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Decisiontable.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Decisiontable.Border.Bottom.Width": {
    defaultValue: "0px"
  },

  "Decisiontable.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Decisiontable.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Decisiontable.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Decisiontable.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },

  "Decisiontable.Shadow": {
    defaultValue: "none"
  },
  "Decisiontable.Shadow.Type": {
    defaultValue: "none"
  },
  "Decisiontable.Shadow.Color": {
    ref: "Color.Shadow"
  },
  // Decisiontable comp

  "Decisiontable.Color": {
    ref: "Color.Transparent"
  },

  "Decisiontable.Title.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Decisiontable.Title.Padding.Top": {
    defaultValue: "0px"
  },
  "Decisiontable.Title.Padding.Right": {
    defaultValue: "0px"
  },
  "Decisiontable.Title.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Decisiontable.Title.Padding.Left": {
    defaultValue: "0px"
  },
  "Decisiontable.Title.Font.Size": {
    ref: "Font.Size.16"
  },
  "Decisiontable.Title.Color": {
    ref: "Color.Gray.800"
  },
  "Decisiontable.Title.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },

  "Decisiontable.Cell.Border.Color": {
    ref: "Color.Gray.300"
  },
  "Decisiontable.Header.Bg.Color": {
    ref: "Color.Gray.200"
  },
  "Decisiontable.Header.Color": {
    ref: "Color.Gray.800"
  },
  "Decisiontable.Header.Font.Size": {
    ref: "Font.Size.14"
  },
  "Decisiontable.Header.Icon.Color": {
    ref: "Color.Gray.700"
  },
  "Decisiontable.Header.Icon.Hover.Color": {
    ref: "Color.Gray.500"
  },
  "Decisiontable.Row.Expand.Color": {
    ref: "Color.Gray.700"
  },
  "Decisiontable.Cell.Selection.Color": {
    ref: "Color.Primary.500"
  },
  "Decisiontable.Cell.Readonly.Bg.Color": {
    ref: "Color.Gray.100"
  },
  "Decisiontable.Cell.Placeholder.Color": {
    ref: "Input.Cell.Placeholder.Color"
  },
  "Decisiontable.Footer.Bg.Color": {
    ref: "Color.Gray.100"
  },
  "Decisiontable.Cursor": {
    defaultValue: "pointer"
  },
  "Decisiontable.Box.Sizing": {
    defaultValue: "border-box"
  }
};
